import {matchMedia} from '@acng/frontend-bounty/cssom/media.js';
import {value} from '@acng/frontend-relativity';
import {ImageTile} from 'acng/core/tiles/ImageTile';
import {ctxBonusList} from 'acng/payment/context/bonus-list.js';

export class BonusTile extends ImageTile {
  dontSetBg = true;
  /**
   * @param {Scope} scope
   * @param {BonusTileArg} arg
   */
  async load(scope, arg) {
    scope.format = arg.format || 'otm';
    scope.bonus ??= arg.bonus ?? value(ctxBonusList)[0];
    if (this.image) {
      this.image.remove();
    }
    if (!this.isCompiled) {
      scope.$watch('bonus', (bonus) => {
        if (scope.bonus == bonus || scope.bonus?.name == bonus?.name) {
          return;
        }
        this.disabled = !scope.bonus;
        if (this.disabled) {
          if (arg.overlay) {
            arg.overlay.close();
          }
        }

        scope.$emit('tile.update', this);
      });
    }
    if (!scope.bonus) {
      this.disabled = true;
      throw 'no bonus';
    } else {
      this.disabled = false;
    }

    if (scope.format == 'overlay' && matchMedia('(orientation: portrait)')) {
      scope.format = 'sidebar';
    }

    await super.load(scope, {
      caption: 'payment.bonus.otmHeading',
      src: await scope.bonus.getImageUrl(scope.format),
      click: arg.noclick
        ? undefined
        : () => {
            if (arg.overlay) arg.overlay.close();
            scope.bonus?.click();
          },
    });
    this.disabled = false;
    const oldImage = this.box?.querySelector(':scope > img');
    if (oldImage) {
      oldImage.remove();
    }
    this.box?.prepend(this.image);
  }
  /**
   * @returns {string} -
   */
  hookname() {
    return 'bonus';
  }
}

/**
 * @typedef {{
 *   format?: string;
 *   noclick?: boolean;
 *   overlay?: import('acng/core/service/overlay').Overlay;
 *   bonus?: import('acng/payment/model/bonus').Bonus | null | undefined;
 * }} BonusTileArg
 */

/**
 * @typedef {angular.IScope & import('acng/core/tiles/ImageTile').ImageTileScope & {
 *   format: string;
 *   bonus: import('acng/payment/model/bonus').Bonus | null | undefined;
 * }} Scope
 */
